import { useQuery } from "react-query";
import DashboardApiClient from "api/DashboardApiClient";

export function useMapFilters() {
    return useQuery("mapfilters", () => DashboardApiClient.getMapFilters());
}
